<template>
  <div class="wrapper hefei-bg-f5">
    <div class="container-wrap-form pay-detail fail">
      <div class="icon-pay-fail">
        <img src="../../assets/images/jidayi-hospital/icon-pay-fail.png" alt />
      </div>
      <h2 class="fc-F12500">支付失败</h2>
      <h5 class="fc-9d">订单支付超时，请返回结算列表重新发起支付</h5>
      <div class="fail-btn">
        <a>重新支付</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    
}
</script>



// WEBPACK FOOTER //
// src/components/patientEnd/paymentFailed.vue